module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_115_9.682a001b.pdf";